module.exports = __webpack_public_path__ + "static/media/grand-pere-jean-sponsor.4ec93bee.png";